import { forwardRef } from 'react'
import { useTranslation } from '@front/model'
import { createPolymorphicComponent } from '@mantine/core'
import { TButton, type TButtonProps } from './button'

type ButtonCancelProps = Omit<TButtonProps, 'leftSection' | 'icon'>

const _ButtonCancel = forwardRef<HTMLButtonElement, ButtonCancelProps>(({ children, ...props }, ref) => {
  const { t } = useTranslation()
  return (
    <TButton icon='close' variant='gray' {...props} ref={ref}>
      {children || t('Cancel')}
    </TButton>
  )
})

_ButtonCancel.displayName = 'ButtonCancel'

export const ButtonCancel = createPolymorphicComponent<'button', ButtonCancelProps>(_ButtonCancel)
